import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import InlineSvg from './InlineSvg';
import { useCookies } from 'react-cookie';

const Popup = () => {
  const data = useStaticQuery(graphql`
    {
      wp(acfOptionsPopupSettings: { popupSettingsOptions: {} }) {
        acfOptionsPopupSettings {
          popupSettingsOptions {
            active
            triggerTime
            popupTitle
            popupText
            popupLink {
              url
              target
            }
            popupLinkText
            exemptPages {
              pageWithNoPopup {
                url
              }
            }
          }
        }
      }
    }
  `);

  let {
    wp: {
      acfOptionsPopupSettings: {
        popupSettingsOptions: {
          active,
          triggerTime,
          popupTitle,
          popupText,
          popupLinkText,
          popupLink,
          exemptPages,
        },
      },
    },
  } = data;
  const [popupDisabled, setPopupDisabled] = React.useState(true);
  const [mouseIn, setMouseIn] = React.useState(true);
  const [isActive, setIsActive] = React.useState(false);
  const [exemptPage, setExemptPage] = React.useState(true);
  const surveyShowCookie = 'Citipower Seen Survey Popup';
  const surveyTimeCookie = 'Show Alert Timer';
  const surveyVCookie = 'version number';
  const [surveyCookies, setSurveyCookie] = useCookies([
    surveyShowCookie,
    surveyTimeCookie,
    surveyVCookie,
  ]);

  const ref = React.useRef()

  //   // check if page is exempt
  React.useEffect(() => {
    if (exemptPages?.length >= 1) {
      const notAnExemptPage = exemptPages?.every(
        (page) =>
          window?.location?.href !==
          window?.location?.origin + page?.pageWithNoPopup?.url
      );
      if (notAnExemptPage) {
        setPopupDisabled(false);
        setExemptPage(false);
      }
    }
  }, [exemptPages, exemptPage]);

  //   // popup side effect
  React.useEffect(() => {
    const surveyCookieAge = 60 * 60 * 24 * 7; // (seconds in a week;)----
    const surveyCookieOptions = { path: '/', maxAge: surveyCookieAge };
    const today = new Date();
    const todayPlusHour = today.setTime(today.getTime() + 1 * 60 * 60 * 1000); //3600000 an hour
    const currentTime = new Date();

    function saveCookie() {
      currentTime.setTime(currentTime.getTime());
      if (surveyCookies[surveyShowCookie] == undefined) {
        setSurveyCookie(surveyShowCookie, true, surveyCookieOptions);
        setSurveyCookie(surveyTimeCookie, todayPlusHour, surveyCookieOptions);
      }
    }

    if (!document?.cookie?.match('Citipower Seen Survey Popup')) {
      let popupTimer;
      if (!exemptPage) {
        popupTimer = setTimeout(() => {
          setIsActive(true);
          saveCookie();
          ref?.current?.focus()
        }, 1000 * triggerTime);
      }
      
      if (exemptPage) {
        return () => {
          clearTimeout(popupTimer);
        };
      }
    }
    
    // logic for popup showing on cursor leaving document via top
    const handleMouseMove = (event) => {
      if (
        event?.clientY <= 0 &&
        !document?.cookie?.match('Citipower Seen Survey Popup')
        ) {
          setIsActive(true);
          setMouseIn(false);
          saveCookie();
          ref?.current?.focus()
      }

      if (event?.clientY <= 0 && isActive) {
        setMouseIn(false);
      }
    };

    document.addEventListener('mouseleave', handleMouseMove);

    return () => {
      document.removeEventListener('mouseleave', handleMouseMove);
    };
  }, [
    surveyCookies,
    mouseIn,
    isActive,
    setSurveyCookie,
    exemptPage,
    triggerTime,
  ]);

  function closePopup() {
    setIsActive(false);
    setPopupDisabled(true);
  }

  return (
    <>
      {active ? (
        <>
          <div
            className={`popupBackdrop ${
              !popupDisabled && isActive && !mouseIn ? 'backdropOn' : ''
            }`}
          ></div>
          <div
            className={`popupWrapper ${
              !popupDisabled && isActive ? 'popupActive' : ''
            } ${!popupDisabled && isActive && !mouseIn ? 'fullscreen' : ''} ${
              !mouseIn ? 'largeContainer' : ''
            }`}
          >
            <div className="popupContainer">
              <div className="popupCloseWrapper">
                <button
                ref={ref}
                  tabIndex={isActive ? '0' : '-1'}
                  className="popupClose"
                  onClick={closePopup}
                  aria-label='close popup'
                >
                  <InlineSvg
                    name="close"
                    className="mobile-menu__portal-arrow"
                    color="brand-secondary"
                  />
                </button>
              </div>
              <div className="popupContent">
                <h4>{popupTitle && popupTitle}</h4>
                <p>{popupText && popupText}</p>
                <span className="linkSpan">
                  <a
                    href={`${popupLink?.url}`}
                    target={popupLink?.target}
                    tabIndex={isActive ? '0' : '-1'}
                  >
                    {popupLinkText && popupLinkText}
                  </a>

                  <InlineSvg
                    name="arrow"
                    className="mobile-menu__portal-arrow"
                    color="brand-primary"
                  />
                </span>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default Popup;
